import { NextPage } from 'next';

import RentalSearchTemplate from '@/components/templates/RentalSearchTemplate';
import type { TPageWithHeader } from '@/components/ui/GlobalHeader/GlobalHeaderV2/headerConfig';

interface IError {
  statusCode: number;
  message?: string;
}

interface IProps {
  error: IError | null;
}

const SearchPage: NextPage<IProps> & TPageWithHeader = () => {
  return <RentalSearchTemplate isCampgrounds />;
};

SearchPage.header = { preset: 'serp', campground: true };

export default SearchPage;
